<template>
  <li class="interactives-list-item">
    <span class="item-content">{{ itemContent }}</span>
    <button class="item-close" @click="$emit('remove')">(Remove)</button>
  </li>
</template>

<script>

export default {
  name: 'interactives-list-item',
  props: ['itemContent']
}
</script>

<style>
.interactives-check-input {
  /* styles go here */
}
</style>



// WEBPACK FOOTER //
// ../interactives-input/src/components/ListItem.vue